// src/components/auth/ForgotPassword.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { forgotPassword } from '../../features/auth/authSlice';

const ForgotPassword = () => {
    const dispatch = useDispatch();

    const [email, setEmail] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email.trim()) {
            setError('Email is required');
            return;
        }

        if (!/\S+@\S+\.\S+/.test(email)) {
            setError('Please enter a valid email');
            return;
        }

        setIsSubmitting(true);
        setError('');

        try {
            await dispatch(forgotPassword({ email })).unwrap();
            setIsSubmitted(true);
        } catch (error) {
            setError(error.message || 'An error occurred. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    // If form was submitted successfully, show confirmation
    if (isSubmitted) {
        return (
            <div className="auth-container">
                <div className="auth-form-container">
                    <div className="auth-message-box">
                        <h1>Check Your Email</h1>
                        <p>
                            We've sent a password reset link to <strong>{email}</strong>.
                            Please check your email and follow the instructions to reset your password.
                        </p>
                        <p className="small">
                            If you don't see the email in your inbox, please check your spam folder.
                        </p>
                        <div className="auth-links">
                            <Link to="/login" className="btn btn-outline">Back to Login</Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="auth-container">
            <div className="auth-form-container">
                <h1>Reset Your Password</h1>
                <p className="auth-subtitle">
                    Enter your email address and we'll send you a link to reset your password.
                </p>

                {error && <div className="error-message">{error}</div>}

                <form onSubmit={handleSubmit} className="auth-form">
                    <div className="form-group">
                        <label htmlFor="email">Email Address</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className={error ? 'error' : ''}
                        />
                    </div>

                    <button
                        type="submit"
                        className="btn btn-primary btn-block"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Sending...' : 'Send Reset Link'}
                    </button>
                </form>

                <div className="auth-links">
                    <p><Link to="/login">Back to Sign In</Link></p>
                </div>
            </div>

            <div className="auth-info">
                <h2>Forgot Your Password?</h2>
                <p>No worries! It happens to the best of us. We'll help you get back into your account.</p>
            </div>
        </div>
    );
};

export default ForgotPassword;
